module.exports = __webpack_public_path__ + "f395a44433fb2bac1fb62db6670ff992.png";